import moment from "moment-timezone";
export const formatDate=(date)=>{
    return moment(date).format('DD/MM/YYYY');
  }